import { FC, useEffect } from "react";
import { Link } from "react-router-dom";
import { Paragraph, Span } from "../Typography";
import { GullButton } from "../buttons/GullButton";
import { Box, styled, useTheme } from "@mui/system";
import useCommonContext from "../../hooks/useCommonContext";
import {
  Avatar,
  Divider,
  Drawer,
  List,
  ListItem,
  useMediaQuery,
} from "@mui/material";
import { themeShadows } from "../../theme/themeColors";

const ChatListDrawer = styled(Drawer)(({ theme }) => ({
  flexShrink: 0,
  width: 240,
  "& .MuiDrawer-paper": {
    width: 240,
    zIndex: 100,
    border: "none",
    marginTop: "50px",
    position: "absolute",
    left: 0,
    height: "calc(100% - 50px)",
    boxShadow: themeShadows[1],
  },
}));

const InboxMenu = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "10px 15px",
  paddingBottom: 0,
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

const MenuItem = styled(ListItem)(({ theme }) => ({
  padding: "10px 2px",
  "& a": {
    display: "flex",
    alignItems: "center",
    "& svg": {
      fontSize: 20,
      marginRight: "8px",
    },
  },
  "& :hover": {
    color: theme.palette.primary.main,
  },
}));

const MessageList = styled(Box)(({ theme }) => ({
  width: "100%",
  cursor: "pointer",
  overflowY: "auto",
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  "& :hover": {
    background: theme.palette.grey[50],
  },
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

const Message = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "15px 15px",
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  "& .userName": {
    width: "100%",
    display: "flex",
    fontSize: 12,
    color: theme.palette.grey[600],
    justifyContent: "space-between",
  },
}));

interface Props {
  messageList: any[];
  inboxMenuData: any[];
  chatListDrawer: boolean;
  setChatListDrawer: (value: boolean) => void;
}
const InboxNavDrawer: FC<Props> = (props) => {
  const theme = useTheme();
  const { setComposeFormModal } = useCommonContext();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const { messageList, inboxMenuData, chatListDrawer, setChatListDrawer } =
    props;

  useEffect(() => {
    if (matches) {
      setChatListDrawer(false);
    }
  }, [matches]);

  return (
    <ChatListDrawer
      variant="persistent"
      open={chatListDrawer || (matches && false)}
    >
      <InboxMenu>
        <GullButton
          fullWidth
          rounded={true}
          variant="contained"
          color="primary"
          sx={{ m: 0 }}
          onClick={() => setComposeFormModal(true)}
        >
          Compose
        </GullButton>
        <Paragraph sx={{ pl: "2px", mt: "20px" }}>Browse</Paragraph>
        <List>
          {inboxMenuData.map((data) => (
            <MenuItem>
              <Link to="#">
                <data.Icon /> {data.name}
              </Link>
            </MenuItem>
          ))}
        </List>
      </InboxMenu>

      <Divider sx={{ borderColor: "#e0e0e0" }} />

      <MessageList>
        {messageList.map((data) => {
          const { name, date, message, photoUrl } = data;
          return (
            <Message>
              <Avatar
                src={photoUrl}
                sx={{ mr: "10px", width: 35, height: 35 }}
              />
              <Box width="100%">
                <Paragraph className="userName">
                  <Span>{name}</Span>
                  <Span>{date}</Span>
                </Paragraph>
                <Paragraph sx={{ mt: "5px", fontSize: 13 }}>
                  {message}
                </Paragraph>
              </Box>
            </Message>
          );
        })}
      </MessageList>
    </ChatListDrawer>
  );
};

export default InboxNavDrawer;
